export class AppSettings {

    public static NAME    = "Brocker Turismo";
    public static PREFIXO = "brocker";

}
